<template>
  <el-container>
    <el-main>
      <div class="nesc_e3s1_top">
        <div class="nesc_cont950 nesc_e3s1t_cont">
          <h1 class="nesc_e3s1_title">{{ jobData.JobName }}</h1>
          <div class="job-require flex-row-left">
            <p class="t">{{ $t('lang.monthlySalary') }}：</p>
            <p class="v">{{ jobData.MonthlySalary }}</p>
            <em class="vline" />
            <p class="t">{{ $t('lang.numberOfRecruits') }}：</p>
            <p class="v">{{ jobData.Amount }}</p>
          </div>

          <div class="title-box">
            <p>{{ $t('lang.descriptionOfJob') }}</p>
          </div>

          <div class="job-classfiy">
            <p>{{ $t('lang.jobCategories') }}：{{ jobData.JobCategory }}</p>
            <p>{{ $t('lang.releaseDate') }}：{{ $route.params.time.replace(/-/g, '/') }}</p>
            <p>{{ $t('lang.workPlace') }}： {{ jobData.Address }}</p>
          </div>

          <div class="job-detail">
            <p>{{ $t('lang.workContent') }}：</p>
            <div class="flex-column-left" style="padding-left: 2px">
              <!-- <p :key="index" v-for="(item, index) in jobContents">{{item}}</p> -->
              <p style="white-space: pre-wrap">{{ jobData.JobContents }}</p>
            </div>

            <p class="padding-top-lg">{{ $t('lang.jobRequirements') }}：</p>

            <div class="flex-column-left" style="padding-left: 2px">
              <!--<p :key="index" v-for="(item, index) in jobRequirements">{{item}}</p>-->
              <p style="white-space: pre-wrap">{{ jobData.JobRequirements }}</p>
            </div>

            <div v-if="jobData.JobWelfare" class="company-welfare" style="">
              <!-- <p>{{ "福利保障:=======" + jobData.JobWelfare }}</p> -->
              <p>{{ $t('lang.companyBenefits') }}：{{ jobData.JobWelfare }}
                <!--
                <span>五险一金</span>
                <span>包住</span>
                <span>带薪年假</span>
                <span>医疗保险</span>
                <span>年底双薪</span>
                -->
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'RecruitmentDetail',
  data: () => {
    return {
      jobData: {},
      jobRequirements: [],
      jobContents: []
    }
  },

  mounted() {
    window.scrollTo(0, 0)
    this.getData()
  },

  updated() {

  },

  methods: {
    getData() {
      this.$http.post(this.isDevelop ? '/JobInfo' : '/api/JobInfoService/JobInfo', { id: this.$route.params.id }).then(
        (responseNews) => {
          responseNews.statusText == 'OK' && responseNews.data && (
          // this.jobRequirements = responseNews.data.Data.JobRequirements.split('；'),
          // this.jobContents = responseNews.data.Data.JobContents.split('；'),
            this.jobData = responseNews.data.Data
          // this.content = decodeURIComponent(responseNews.data.Data.Contents).replace(new RegExp('src="/upload/','g'),"src="+this.imgserver+"/upload/")
          )
        }
      )
    }
  }
}
</script>

<style scoped lang="scss">
.el-container {
  background: rgb(247,248,250) !important;
}

.nesc_e3s1_top {
  padding: 50px 0 52px;
  background: #f7f8fa;
}
.nesc_e3s1t_cont {
  position: relative;
}

.nesc_cont950 {
  width: 950px;
  margin: 0 auto;

  /*标题*/
  .nesc_e3s1_title {
    font-family: "OPPOSans2_En_design-Heavy", "OPPOSans2_En_design-Regular", "微软雅黑", Arial, "PingFangSC-Light", "Helvetica Neue", Helvetica, "Microsoft Yahei", "Hiragino Sans GB", tahoma, SimSun, sans-serif;
    font-size: 24px;
    font-weight: 400;
    line-height: 24px;
    color: #333333;
    margin-bottom: 30px;
  }

  .job-require {
    margin-bottom: 60px;
    font-size: 16px;
    .t {
      color: #666;
    }
    .v {
      color: #ff7900;
    }
    .vline {
      display: inline-block;
      width: 1px;
      height: 12px;
      background: #ccc;
      margin: 0 10px;
    }
  }

  .title-box {
    font-size: 20px;line-height: 24px;margin-bottom: 15px;
    p {
      font-weight: 600;
    }
  }

  .company-welfare,  .job-classfiy, .job-detail {
    font-size: 14px;margin-top: 24px;line-height: 30px;
  }

  .company-welfare {
    p {
      span {
        border-radius: 100px;
        font-size: 12px;
        padding: 4px 12px;
        background: rgba(0, 0, 0, .05);
        margin-right: 8px;
      }
    }
  }
}

@media screen and (max-width: 1680px) {
  .nesc_e3s1_title {
    font-size: 34px;
  }
}

@media screen and (max-width: 1440px) {
  .nesc_e3s1_title {
    font-size: 32px;
  }
}

@media screen and (max-width: 991px) {
  .nesc_e3s1_top {
    padding: 50px 0 35px;
  }
  .nesc_cont950 {
    width: 100%;
    padding: 0 30px;
  }
  .nesc_e3s1_title {
    font-size: 22px;
    line-height: 1.5;
    margin-bottom: 20px;
  }

  .nesc_e3s1_bot {
    padding: 30px 0;
  }
  .nesc_cont950 {
    width: 100%;
    padding: 0 30px;
  }
}

@media screen and (max-width: 767px) {
  .nesc_e3s1_top {
    padding: 35px 0;
  }
  .nesc_e3s1_bot {
    padding-bottom: 30px;
  }
}

</style>
